/**
 * Formatting Utilities
 */

/**
 * Format a number as currency
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

/**
 * Format a date string to readable format
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);
};

/**
 * Format a date string to readable date and time
 */
export const formatDateTime = (dateString: string): string => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(date);
};

/**
 * Format policy number with dashes
 */
export const formatPolicyNumber = (policyNumber: string): string => {
  return policyNumber.toUpperCase().trim();
};

/**
 * Mask card number to show only last 4 digits
 */
export const maskCardNumber = (cardNumber: string): string => {
  if (cardNumber.length <= 4) {
    return cardNumber;
  }
  return `****${cardNumber.slice(-4)}`;
};

/**
 * Format address object to multi-line string
 */
export const formatAddress = (address: {
  street: string;
  city: string;
  state: string;
  zip: string;
}): string => {
  return `${address.street}\n${address.city}, ${address.state} ${address.zip}`;
};
